<template>
  <div class="search-view">
    <search></search>
  </div>
</template>

<script>
import Search from '@/components/Search/Search.vue'
export default {
  name: 'SearchView',
  components: {
    Search
  }
}
</script>
